
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const EnglishFAQSection = () => {
  return (
    <div className="mb-10">
      <h2 className="text-2xl font-semibold mb-6 text-blue-700">Frequently Asked Questions</h2>
      
      <Accordion type="single" collapsible className="bg-white rounded-lg shadow-sm border border-blue-100 mb-6">
        <AccordionItem value="item-1">
          <AccordionTrigger className="px-4 py-3 text-left hover:bg-blue-50">
            How long does it take to get a loan decision?
          </AccordionTrigger>
          <AccordionContent className="px-4 py-3 text-gray-700">
            Through our service, you'll typically receive offers from multiple banks within 24 hours. 
            Some lenders may provide an immediate preliminary decision. The final approval time depends 
            on the loan type and amount.
          </AccordionContent>
        </AccordionItem>
        
        <AccordionItem value="item-2">
          <AccordionTrigger className="px-4 py-3 text-left hover:bg-blue-50">
            Will applying through Lainasampo affect my credit score?
          </AccordionTrigger>
          <AccordionContent className="px-4 py-3 text-gray-700">
            When you apply through Lainasampo, a credit check is performed. In Finland, this check is 
            recorded by Suomen Asiakastieto, but multiple applications through our service during the 
            same period are counted as a single inquiry for scoring purposes.
          </AccordionContent>
        </AccordionItem>
        
        <AccordionItem value="item-3">
          <AccordionTrigger className="px-4 py-3 text-left hover:bg-blue-50">
            What is the minimum and maximum loan amount available?
          </AccordionTrigger>
          <AccordionContent className="px-4 py-3 text-gray-700">
            The loan amounts vary by lender and loan type. Consumer loans typically range from €1,000 
            to €60,000, while mortgages can be up to several hundred thousand euros. The specific 
            amounts available to you depend on your income and credit history.
          </AccordionContent>
        </AccordionItem>
        
        <AccordionItem value="item-4">
          <AccordionTrigger className="px-4 py-3 text-left hover:bg-blue-50">
            Can I apply if I'm not a Finnish citizen?
          </AccordionTrigger>
          <AccordionContent className="px-4 py-3 text-gray-700">
            Yes, but you typically need a Finnish personal ID number (henkilötunnus) and permanent 
            residency in Finland. Some lenders may also require that you've lived in Finland for a 
            minimum period (usually 1-2 years) and have a stable income history in Finland.
          </AccordionContent>
        </AccordionItem>
        
        <AccordionItem value="item-5">
          <AccordionTrigger className="px-4 py-3 text-left hover:bg-blue-50">
            How are the interest rates determined?
          </AccordionTrigger>
          <AccordionContent className="px-4 py-3 text-gray-700">
            Interest rates are determined based on your personal financial situation, loan amount, 
            loan term, and the current market conditions. Your credit score, income level, and 
            employment status all play a role in the interest rate you're offered.
          </AccordionContent>
        </AccordionItem>
      </Accordion>
      
      <div className="text-center">
        <Link 
          to="/english/apply" 
          className="inline-flex items-center bg-blue-600 hover:bg-blue-700 text-white px-5 py-3 rounded shadow-md transition-colors font-medium"
        >
          Apply for a loan now
          <ArrowRight className="ml-2 h-5 w-5" />
        </Link>
      </div>
    </div>
  );
};
